import { type UseQueryResult, keepPreviousData, useQuery } from '@tanstack/react-query';

import api from '@/api/axios';
import type { AuditSelfAssessment } from '@/types';
import { shouldRetryRequest } from '@/utils/shouldRetryRequest';

const fetchAuditCase = async (auditCaseId: string): Promise<AuditSelfAssessment> => {
  const { data } = await api.get<AuditSelfAssessment>(`/audit-cases/${auditCaseId}`);

  return data;
};

export const useGetAuditCase = (
  auditCaseId: string,
  enabled = true,
): UseQueryResult<AuditSelfAssessment, Error> => {
  return useQuery({
    queryKey: ['audit-case', auditCaseId],
    queryFn: () => fetchAuditCase(auditCaseId),
    placeholderData: keepPreviousData,
    retry(failureCount, error) {
      return shouldRetryRequest(failureCount, error);
    },
    enabled,
  });
};
